import axios from "axios";

const restApiUrl = 'https://institutigap.org/komunat/interface/json/';

export const client = axios.create({
	baseURL: restApiUrl,
	timeout: 10000 
});